module.exports = __webpack_public_path__ + "static/media/Duck.82355d3e.webm";